export type BaseType = string | number | boolean;
export type ParamType = string | number | boolean | ReadonlyArray<string | number | boolean>;
export type AbstractObject =
	| BaseType
	| Array<BaseType | Array<BaseType> | Record<string, BaseType>>
	| Record<string, BaseType | Array<BaseType> | Record<string, BaseType>>;
